import projectApi from '../../api/rest/projectApi';
import {EResponseCode} from '../../const/dataEnum';
import {setSelectedProject, setProjects} from '../actions/teamAssignmentAction';

const fetchProjectLeads = () => async (dispatch) => {
  try {
    const res = await projectApi.getProjectLeads();

    const {data, responseCode} = res;

    if (responseCode === EResponseCode.NO_ERROR) {
      const formatted = data.map((project) => ({
        id: project.id,
        text: project.projectName,
        group: '',
        data: project,
      }));

      dispatch(setProjects(formatted));
      if (formatted.length > 0) {
        dispatch(setSelectedProject(formatted[0]));
      }
    }
  } catch (error) {}
};

const getProjects = () => async (dispatch) => {
  const res = await projectApi.getAll();
  if (res) {
    return res;
  }
  return null;
};

const getProjectById = (projects, projectId) => {
  const project = projects.find((p) => p.id === projectId);
  if (project) {
    return project;
  }
  return null;
};

const projectBusiness = {
  getProjects,
  getProjectById,
  fetchProjectLeads,
};

export default projectBusiness;
